import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@service/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if ([401, 403, 429].indexOf(err.status) !== -1) {
          
          // Redirect to root page if the route starts with /sistema
          if (request.url.startsWith('/sistema')) {
            this._router.navigate(['/']);
          }
          
          // this._router.navigate(['/']);

          if (this._authenticationService.currentUserValue) {
            this._authenticationService.logout();
          }
          // location.reload();
        }
        // throwError
        throw err.error?.error || err.statusText;
      })
    );
  }
}
